import { GET_OTA_AVAILABLE_ROUTES_URL } from "../../utils/api-url";
import { getCall } from "../../utils/network.util";
import { isValid } from "../../utils/utilities";

export const fetchOtaAvailableRoutesUrl = (params = {}, onSuccess = () => {}, onFailure = () => {}) => {
    const { origin, destination, date } = params;

    if (!isValid(origin) || !isValid(destination) || !isValid(date)) {
        onFailure();
        return;
    }

    const url = `${GET_OTA_AVAILABLE_ROUTES_URL}?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&date=${encodeURIComponent(date)}`;

    getCall(url)
        .then((response) => {
            if (response.status === "SUCCESS" && response.payload.Status === "SUCCESS") {
                onSuccess(response.payload.Payload.otaUrl);
            } else {
                onFailure();
            }
        })
        .catch((err) => {
            console.log({ err });
            onFailure();
        });
}
